/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { SearchResultItem } from '../../api/search/search.types';

// Built once: a results page calls this for every card on every render
const usdFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
});

export function getPriceRange(item: SearchResultItem) {
    let priceRangeLabel: string | undefined;
    let priceRangeUnit: string | undefined;
    let priceRangeAriaLabel: string | undefined;

    const pricedEntityTypes = ['campground', 'venuereservations'];
    const isPricedEntityType = pricedEntityTypes.includes(item?.entity_type ?? '');
    const isReservable = item?.reservable ?? false;

    if (isPricedEntityType && isReservable && item.price_range) {
        const minAmount = item.price_range.amount_min;
        const maxAmount = item.price_range.amount_max;

        if (minAmount && maxAmount) {
            if (minAmount > -1) {
                priceRangeLabel =
                    minAmount === maxAmount
                        ? usdFormatter.format(minAmount)
                        : `${usdFormatter.format(minAmount)} – ${usdFormatter.format(maxAmount)}`;

                priceRangeAriaLabel = priceRangeLabel;
            }
        }

        if (item.price_range?.per_unit) {
            priceRangeUnit = ` / ${item.price_range.per_unit}`;
            priceRangeAriaLabel += ` per ${item.price_range.per_unit}`;
        }
    }

    return { priceRangeLabel, priceRangeUnit, priceRangeAriaLabel };
}

// cSpell:ignore venuereservations
